// CalendarEvent
import {enum_routeScrollableMode_e} from "../../functions/src/shareCode/Share_S_Enum";
import {FB_MapPoint} from "../../functions/src/shareCode/Share_S_Classes";


// Cla_CalendarEvent
export class Cla_CalendarEvent{

    constructor(obj){
        this.startingDate       = obj.startingDate
        this.endingDate         = obj.endingDate
        this.title              = obj.title
        this.clickCallback      = obj.clickCallback
        this.key                = obj.key
        this.backgroundColor    = obj.backgroundColor
        this.color              = obj.color
    }

}

// routeData
export class Cla_ViewRouteMetadata {

    constructor(obj){
        this.vrm_backTo_s           = obj.vrm_backTo_s;
        this.vrm_showBackBtn_b      = obj.vrm_showBackBtn_b   ? obj.vrm_showBackBtn_b     : false;
        this.vrm_hideTopBar_b       = obj.vrm_hideTopBar_b    ? obj.vrm_hideTopBar_b      : false;
        this.vrm_hideBottomBar_b    = obj.vrm_hideBottomBar_b ? obj.vrm_hideBottomBar_b   : false;
        this.vrm_scrollMode_e       = obj.vrm_scrollMode_e    ? obj.vrm_scrollMode_e      : enum_routeScrollableMode_e.topToBottom;
    }
}

// Cla_OsmSearch
export class Tq_OsmSearch {
    constructor(obj){
        this.osms_boundingbox_an = obj.boundingbox.map(item_s => {return parseFloat(item_s)})
        this.osms_location_c = new FB_MapPoint(
            {
                mp_lat_n : parseFloat(obj.lat),
                mp_lng_n : parseFloat(obj.lon)
            })
        this.osms_displayName_s = obj.display_name
    }
}

// Cla_Laeflet_Marker
export class Tq_Laeflet_Marker {
    constructor(obj){
        this.ltm_text_s         = obj.ltm_text_s
        this.ltm_color_s        = 'black'
        this.ltm_location_c     = new FB_MapPoint(obj.ltm_location_c)
        this.ltm_id_s           = obj.ltm_id_s
    }
}

